module.exports = __webpack_public_path__ + "static/merfolk-1-f166b04ec15f1ff0e6a0be431616d09d.png";